export const VIEW_TYPE = {
  DRAINAGE_PATTERN: 'drainage-pattern',
  CONTOUR_N_SLOPE: 'contour-n-slope',
  GEOLOGY: 'geology',
  GEOMORPHOLOGY: 'geomorphology',
  HYDROLOGY: 'hydrology',
};
